<template>
  <v-container class="px-0 py-0" fluid>
    <v-row dense>
      <v-col>
        <SearchInspBoxForm />
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import SearchInspBoxForm from '@/components/organisms/terminal/form/SearchInspBoxForm.vue'

export default {
  name: 'SearchInspBoxPage',

  components: {
    SearchInspBoxForm,
  },
}
</script>
